import React, { useEffect } from 'react';
import styles from './index.module.scss';
import PublicationMainBlockV2 from '../../_block_components/publication_main_block_v2';
import PublicationContentBlockV2 from '../../_block_components/publication_content_block_v2';

const PublicationPageV2 = ({ contentData, path_to_folder }) => {
  // Лог всех изображений, рендерящихся на странице publication2
  useEffect(() => {
    if (!contentData || !Array.isArray(contentData) || !path_to_folder) return;
    const base = path_to_folder.startsWith('http') ? path_to_folder : `https://${path_to_folder}`;
    const imageUrls = [];
    const blocks = contentData.filter((_, index) => index !== 0);
    blocks.forEach((block) => {
      const tag = block.boock_tag || block.block_tag;
      const content = block.block_content;
      if (!content || !Array.isArray(content)) return;
      if (tag === 'main_block') {
        content.forEach((el) => {
          if ((el.cotent_tag === 'img_or_video' || el.content_tag === 'img_or_video') && el.img_name && el.img_name !== 'none') {
            const cleaned = el.img_name.split('/').pop().split('\\').pop();
            imageUrls.push(`${base}${cleaned}`);
          }
        });
      } else if (tag === 'content_block') {
        content.forEach((el) => {
          if ((el.cotent_tag === 'images' || el.content_tag === 'images') && el.imgs_names && el.imgs_names !== 'none') {
            const names = el.imgs_names
              .split(',')
              .map((name) => name.trim().replace(/['"[\]]/g, '').split('/').pop().split('\\').pop())
              .filter((name) => name && name !== 'none');
            names.forEach((name) => imageUrls.push(`${base}${name}`));
          }
        });
      }
    });
    if (imageUrls.length > 0) {
      // console.log('[PublicationPageV2] Все изображения на странице:', imageUrls);
    }
  }, [contentData, path_to_folder]);

  const renderBlock = (el) => {
    if ((el.boock_tag === 'main_block' || el.block_tag === 'main_block')) {
      const result = <PublicationMainBlockV2 blockData={el} path_to_folder={path_to_folder} />;
      return result;
    } else if ((el.boock_tag === 'content_block' || el.block_tag === 'content_block')) {
      const result = <PublicationContentBlockV2 blockData={el} path_to_folder={path_to_folder} />;
      return result;
    }
    return null;
  };

  // Проверяем, есть ли контент для рендеринга
  if (!contentData || !Array.isArray(contentData)) {
    return null;
  }

  const blocksToRender = contentData
    .filter((block, index) => index !== 0)
    .map((block, index) => {
      const renderedBlock = renderBlock(block);
      return renderedBlock ? (
        <div key={index + 1} className={styles.blockWrapper}>
          {renderedBlock}
        </div>
      ) : null;
    })
    .filter((block) => block !== null);

  // Если нет блоков для рендеринга, не рендерим контейнер
  if (blocksToRender.length === 0) {
    return null;
  }


  return (
    <div className={styles.publicationPageV2}>
      <div className={styles.blocksContainer}>{blocksToRender}</div>
    </div>
  );
};

export default PublicationPageV2;
